import { NumberBadge } from '@calendly/ui/components/badge'

export const FilterMenuCountBadge = ({ count }) => {
  if (!count || count <= 0) return null

  return <NumberBadge>{count}</NumberBadge>
}
